<template>
  <a-modal
    title="维修耗材"
    :visible="showTubeView"
    :width="700"
    destroyOnClose
    @ok="handleOk"
    @cancel="closeTubeView"
  >
    <!-- style="position: absolute; left: 18rem; z-index: 999; top: 3rem" -->
    <template slot="footer">
      <a-button @click="closeTubeView">取消</a-button>
      <a-button :disabled="isUpdate" type="primary" @click="handleOk">确定</a-button>
    </template>
    <a-form-model
      class="log-form"
      :model="addOrUpdateForm"
      ref="addOrUpdateForm"
      :rules="rules"
      :label-col="{ span: 6 }"
      :wrapper-col="{ span: 14 }"
    >
      <a-row class="form-row" type="flex" justify="center" :gutter="4">
        <a-col :md="24" :sm="24">
          <a-form-model-item
            label="工单号"
            prop="workNo"
            :label-col="{ span: 5 }"
            :wrapper-col="{ span: 14 }"
          >
            <a-input :disabled="isUpdate" placeholder="请输入" v-model="addOrUpdateForm.workNo" />
          </a-form-model-item>
        </a-col>
        <a-col :md="24" :sm="24">
          <a-form-model-item
            label="材料名称"
            prop="materialName"
            :label-col="{ span: 5 }"
            :wrapper-col="{ span: 14 }"
          >
            <a-input :disabled="isUpdate" placeholder="请输入" v-model="addOrUpdateForm.materialName" />
          </a-form-model-item>
        </a-col>
        <a-col :md="24" :sm="24">
          <a-form-model-item
            label="数量(个)"
            prop="count"
            :label-col="{ span: 5 }"
            :wrapper-col="{ span: 14 }"
          >
            <a-input :disabled="isUpdate" placeholder="请输入" v-model="addOrUpdateForm.count" />
          </a-form-model-item>
        </a-col>
        <a-col :md="24" :sm="24">
          <a-form-model-item
            label="领取人"
            prop="recipients"
            :label-col="{ span: 5 }"
            :wrapper-col="{ span: 14 }"
          >
            <a-input :disabled="isUpdate" placeholder="请输入" v-model="addOrUpdateForm.recipients" />
          </a-form-model-item>
        </a-col>
        <a-col :md="24" :sm="24">
          <a-form-model-item
            label="领取时间"
            prop="receiveTime"
            :label-col="{ span: 5 }"
            :wrapper-col="{ span: 14 }"
          >
            <a-date-picker
              v-model="addOrUpdateForm.receiveTime"
              show-time
              :disabled="isUpdate" placeholder="领取时间"
              @change="onChange"
            />
          </a-form-model-item>
        </a-col>
<!--        <a-col :md="24" :sm="24">-->
<!--          <a-form-model-item-->
<!--            label="登记人"-->
<!--            prop="registerPerson"-->
<!--            :label-col="{ span: 5 }"-->
<!--            :wrapper-col="{ span: 14 }"-->
<!--          >-->
<!--            <a-input :disabled="isUpdate" placeholder="请输入" v-model="addOrUpdateForm.registerPerson" />-->
<!--          </a-form-model-item>-->
<!--        </a-col>-->
      </a-row>
    </a-form-model>
  </a-modal>
</template>
<script>
import moment from 'moment'
export default {
  components: {},
  props: {},
  data() {
    return {
      isUpdate: false,
      queryOneUrl: '/pipe-network/maintenance_consumables/',
      addOrUpdateUrl: '/pipe-network/maintenance_consumables',
      showTubeView: false,
      id: '',
      addOrUpdateForm: {
        workNo: '',
        materialName: '',
        count: '',
        recipients: '',
        receiveTime: '',
        registerPerson: ''
      },

      userlist: [],
      currentId: ''
    }
  },
  computed: {
    rules() {
      return {
        workNo: [{ required: true, message: '请输入工单号', trigger: 'change' }],
        materialName: [{ required: true, message: '请输入材料名称', trigger: 'change' }],
        count: [{ required: true, message: '请输入数量', trigger: 'change' }],
        recipients: [{ required: true, message: '请输入领取人', trigger: 'change' }],
        receiveTime: [{ required: true, message: '请输入领取时间', trigger: 'change' }],
        // registerPerson: [{ required: true, message: '请输入登记人', trigger: 'change' }],

      }
    }
  },
  created() {},
  methods: {
    moment,
    handleChange(value) {
      this.addOrUpdateForm.principal = value
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    handleOk(e) {
      e.preventDefault()
      this.$refs.addOrUpdateForm.validate(valid => {
        if (valid) {
          this.$http[!this.currentId ? 'post' : 'put'](this.addOrUpdateUrl, {
            id: this.currentId,
            sysType:'巡检',
            ...this.addOrUpdateForm
          })
            .then(res => {
              if (res.code === 0) {
                this.closeTubeView()
                this.$emit('handleOk')
                return this.$message.success(res.message)
              }
            })
            .catch(() => {})
        }
      })
    },
    onChange(value, dateString) {
      this.addOrUpdateForm.receiveTime = dateString
    },
    _updateForm(real, data) {
      let keys = Object.keys(real)
      let dataKeys = Object.keys(data)
      let newObject = {}
      keys.map(key => {
        if (dataKeys.includes(key)) {
          newObject[key] = data[key]
        } else {
          newObject[key] = real[key]
        }
      })
      return newObject
    },
    detail(id) {
      this.showTubeView = true
      this.currentId = id
      this.addOrUpdateForm = {
        workNo: '',
        materialName: '',
        count: '',
        recipients: '',
        receiveTime: '',
        registerPerson: ''
      }
      this.$nextTick(() => {
        this.$refs.addOrUpdateForm.resetFields()
        if (id) {
          this.isUpdate = true
          this.$http
            .get(`${this.queryOneUrl}/${this.currentId}`)
            .then(({ data }) => {
              
              console.log(this._updateForm(this.addOrUpdateForm, data))
              this.addOrUpdateForm = { ...this._updateForm(this.addOrUpdateForm, data) }
            })
            .catch(() => {})
        }
      })
    },
    edit(id) {
      this.showTubeView = true
      this.currentId = id
      this.addOrUpdateForm = {
        workNo: '',
        materialName: '',
        count: '',
        recipients: '',
        receiveTime: '',
        registerPerson: ''
      }
      this.$nextTick(() => {
        this.$refs.addOrUpdateForm.resetFields()
        if (id) {
          this.isUpdate = false
          this.$http
            .get(`${this.queryOneUrl}/${this.currentId}`)
            .then(({ data }) => {
              
              console.log(this._updateForm(this.addOrUpdateForm, data))
              this.addOrUpdateForm = { ...this._updateForm(this.addOrUpdateForm, data) }
            })
            .catch(() => {})
        }
      })
    },
    closeTubeView() {
      this.showTubeView = false
      this.$refs.addOrUpdateForm.resetFields()
      this.$emit('handleOk')
    }
  }
}
</script>

<style lang="less" scoped>
</style>
